import Ideogram from './ideogram';

// Enable references to Ideogram when loaded via traditional script tag
window.Ideogram = Ideogram;

// Enable references to Ideogram when imported as an ES6 module
export default Ideogram;
